// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__leY9q","alert":"SettungsInbox_alert__3paPb"};